import { QueryHandler } from '@/redux/types/query-handler';
import { dispatchSuccessPatchAddDeviceToUnit } from './dispatch-success-patch';
import { AddDeviceToUnitQueryArg } from '../types/query-arg';

export const handleResultAddDeviceToUnit: QueryHandler<
  AddDeviceToUnitQueryArg,
  void | string
> = async (queryArg, { queryFulfilled, ...api }) => {
  await queryFulfilled;
  dispatchSuccessPatchAddDeviceToUnit(queryArg, api);
};
